<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Formaty na wyjściu: <strong>{{ impositionTaskOrderComponent.orderProductComponent.name }} - {{ task.process.name }}</strong>
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="impositionTaskOrderComponent.outputFormatA"
                            v-mask="'######'"
                            label="Format A"
                            suffix="mm"
                            outlined
                            dense
                            :error-messages="outputFormatAErrors"
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="impositionTaskOrderComponent.outputFormatB"
                            v-mask="'######'"
                            label="Format B"
                            suffix="mm"
                            outlined
                            dense
                            :error-messages="outputFormatBErrors"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import parse from '@/mixins/parse'

export default {
    name: 'SlicingFormatsDialog',
    directives: { mask },
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        taskData: {
            type: Object,
            default: () => {}
        },
        impositionTaskOrderComponentData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            task: {
                process: {}
            },
            impositionTaskOrderComponent: {
                orderProductComponent: {}
            }
        }
    },
    validations() {
        const validations = {
            impositionTaskOrderComponent: {
                outputFormatA: {
                    required,
                    minValue: minValue(this.impositionTaskOrderComponent.orderProductComponent.formatA)
                },
                outputFormatB: {
                    required,
                    minValue: minValue(this.impositionTaskOrderComponent.orderProductComponent.formatB)
                },
            }
        }

        return validations
    },
    computed: {
        // Walidacje
        outputFormatAErrors() {
            const errors = []

            if (!this.$v.impositionTaskOrderComponent.outputFormatA.$dirty) return errors
            if (this.$v.impositionTaskOrderComponent.outputFormatA.$invalid) {
                errors.push(`Minimalna wartość ${this.impositionTaskOrderComponent.orderProductComponent.formatA}`)
            }

            return errors
        },
        outputFormatBErrors() {
            const errors = []

            if (!this.$v.impositionTaskOrderComponent.outputFormatB.$dirty) return errors
            if (this.$v.impositionTaskOrderComponent.outputFormatB.$invalid) {
                errors.push(`Minimalna wartość ${this.impositionTaskOrderComponent.orderProductComponent.formatB}`)
            }

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.task = JSON.parse(JSON.stringify(this.taskData))
                this.impositionTaskOrderComponent = JSON.parse(JSON.stringify(this.impositionTaskOrderComponentData))
                this.$v.$touch()
            } else {
                setTimeout(() => {
                    this.task = {
                        process: {}
                    }
                    this.impositionTaskOrderComponent = {
                        orderProductComponent: {}
                    }

                    this.$v.$reset()
                }, 500)
            }
        }
    },
    methods: {
        changeOutputFormatA(value) {
            this.impositionTaskOrderComponent.outputFormatA = this.parseEmptyStringToNull(value)
            this.$v.$touch()
        },
        changeOutputFormatB(value) {
            this.impositionTaskOrderComponent.outputFormatB = this.parseEmptyStringToNull(value)
            this.$v.$touch()
        },
        onSave() {
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-save', this.impositionTaskOrderComponent)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>